module.exports = __webpack_public_path__ + "static/media/shopping-cart.07a3cff0.png";